export default "__VITE_ASSET__7435e1fd__"